export enum DestinationTypeEnum {
  WORDPRESS = 1,
  SHOPIFY = 2,
}

export const DestinationTypeMap = {
  [DestinationTypeEnum.WORDPRESS]: "wordpress",
  [DestinationTypeEnum.SHOPIFY]: "shopify",
};

export enum DestinationStatusEnum {
  // wordpress
  DRAFT = "draft",
  PUBLISH = "publish",
  PENDING = "pending",
  FUTURE = "future",

  // shopify
  HIDDEN = "hidden",
  VISIBLE = "visible",
}

export enum DestinationTabs {
  ALL = "all",
  ADDED = "added",
}
